import axios from 'axios';
import '../services/GlobalVariables';

export const DOCUMENT_TYPES = [
  { value: 'KOT', label: 'KOT' },
  { value: 'COMPLETE_ORDER', label: 'Complete Order' },
  { value: 'TEMPORARY_BILL', label: 'Temporary Bill' },
  { value: 'FINAL_BILL', label: 'Final Bill' },
  { value: 'DELIVERY_NOTE', label: 'Delivery Note' },
  { value: 'CANCELLATION_KOT', label: 'Cancellation KOT' },
];

export const DEFAULT_PRINT_TEMPLATE_DESIGN = {
  header: {
    title: 'KOT',
    showCompanyName: false,
    showKitchenName: true,
    align: 'center',
    bold: true,
    size: 2,
    fontWidth: 2,
    fontHeight: 2,
    charsPerLine: 0,
  },
  info: {
    showKotNo: true,
    showOrderNo: true,
    showTable: true,
    showOrderType: true,
    showWaiter: true,
    showTime: true,
    fontWidth: 1,
    fontHeight: 1,
    charsPerLine: 0,
  },
  items: {
    showSerial: false,
    showQty: true,
    showItemSectionHeading: true,
    showRemarks: true,
    showDealItemNames: true,
    itemBold: true,
    qtyLabel: 'Qty',
    separator: ' : ',
    fontWidth: 1,
    fontHeight: 1,
    charsPerLine: 0,
  },
  footer: {
    show: true,
    text: 'Thank you',
    feedLines: 4,
    cutPaper: true,
    fontWidth: 1,
    fontHeight: 1,
    charsPerLine: 0,
  },
};

const API_URL = `${global.SET_API_URL}printTemplates`;

export const createBlankPrintTemplate = () => ({
  templateName: 'Kitchen KOT',
  documentType: 'KOT',
  paperMm: 80,
  isDefault: false,
  designJson: DEFAULT_PRINT_TEMPLATE_DESIGN,
});

const normalizeTemplate = (template = {}) => ({
  ...createBlankPrintTemplate(),
  ...template,
  paperMm: Number(template.paperMm || 80) === 58 ? 58 : 80,
  isDefault: Boolean(template.isDefault),
  isActive: template.isActive !== false,
  designJson: {
    ...DEFAULT_PRINT_TEMPLATE_DESIGN,
    ...(template.designJson || {}),
    header: {
      ...DEFAULT_PRINT_TEMPLATE_DESIGN.header,
      ...(template.designJson?.header || {}),
    },
    info: {
      ...DEFAULT_PRINT_TEMPLATE_DESIGN.info,
      ...(template.designJson?.info || {}),
    },
    items: {
      ...DEFAULT_PRINT_TEMPLATE_DESIGN.items,
      ...(template.designJson?.items || {}),
    },
    footer: {
      ...DEFAULT_PRINT_TEMPLATE_DESIGN.footer,
      ...(template.designJson?.footer || {}),
    },
  },
});

export const fetchPrintTemplates = async (documentType) => {
  const response = await axios.get(API_URL, {
    params: documentType ? { documentType } : undefined,
  });
  return (response.data?.templates || []).map(normalizeTemplate);
};

export const savePrintTemplate = async (template) => {
  const payload = normalizeTemplate(template);
  const response = await axios.post(API_URL, payload);
  return normalizeTemplate(response.data?.template || payload);
};

export const deletePrintTemplate = async (templateID) => {
  await axios.delete(`${API_URL}/${templateID}`);
};

export const setDefaultPrintTemplate = async (templateID) => {
  await axios.post(`${API_URL}/${templateID}/default`);
};


export const printTemplateProof = async ({ template, printerIP, printerPort }) => {
  const response = await axios.post(`${API_URL}/proof/print`, {
    ...normalizeTemplate(template),
    printerIP,
    printerPort,
  });
  return response.data;
};


